"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectableOptionMenuItemType;
(function (SelectableOptionMenuItemType) {
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Normal"] = 0] = "Normal";
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Divider"] = 1] = "Divider";
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Header"] = 2] = "Header";
})(SelectableOptionMenuItemType = exports.SelectableOptionMenuItemType || (exports.SelectableOptionMenuItemType = {}));
//# sourceMappingURL=SelectableOption.Props.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/utilities/selectableOption/SelectableOption.Props.js
// module id = ../node_modules/office-ui-fabric-react/lib/utilities/selectableOption/SelectableOption.Props.js
// module chunks = 1